import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { CustomerCategoryToken } from '@sleed/bizcommerce-api';
import { customerCategoriesApi } from '~/lib/api/client';
import { formToToken, type CustomerCategoryFormValues } from '~/lib/schemas/customer-category';

export const customerCategoryKeys = {
	all: ['customer-categories'] as const,
	list: () => [...customerCategoryKeys.all, 'list'] as const
};

export function useCustomerCategoriesList() {
	return useQuery<CustomerCategoryToken[]>({
		queryKey: customerCategoryKeys.list(),
		queryFn: async () => (await customerCategoriesApi.getAll()).data.items ?? []
	});
}

export function useCustomerCategoryMutations() {
	const qc = useQueryClient();
	const invalidate = () => qc.invalidateQueries({ queryKey: customerCategoryKeys.list() });
	const create = useMutation({
		mutationFn: async (form: CustomerCategoryFormValues) => (await customerCategoriesApi.insert(formToToken(form))).data,
		onSuccess: invalidate
	});
	const update = useMutation({
		mutationFn: async (form: CustomerCategoryFormValues) => (await customerCategoriesApi.update(formToToken(form))).data,
		onSuccess: invalidate
	});
	const remove = useMutation({
		mutationFn: async (id: number) => (await customerCategoriesApi.remove(id)).data,
		onSuccess: invalidate
	});
	return { create, update, remove };
}
